import dayjs from 'dayjs';
import { atom } from 'jotai';
import { groupBy, sumBy } from 'lodash';

import { YEAR_MONTH_DAY_FORMAT } from '@/constants/date.constants';
import type { LimaSourceEventsPerDayDTO } from '@/features/DevicesTable/DevicesTable.types';

export const limaSourceEventsPerDayAtom = atom<LimaSourceEventsPerDayDTO[]>([]);

export const limaSourceEventsByDayAtom = atom((get) => {
  const limaSourceEventsPerDay = get(limaSourceEventsPerDayAtom);
  const timeFrame = 30;
  const groupedEvents = groupBy(limaSourceEventsPerDay, 'date');
  const sizes = [];
  const now = dayjs();

  const data = [];

  // make sure every day is represented in the array by looping through the time frame and checking if there is a record for that day
  for (let i = 0; i <= timeFrame; i += 1) {
    const date = `${now
      .subtract(timeFrame - i, 'days')
      .format(YEAR_MONTH_DAY_FORMAT)}`;

    // groupedEvents[date] is an array and contains log and net events for that day
    const count = groupedEvents[date] ? sumBy(groupedEvents[date], 'count') : 0;
    const size = groupedEvents[date] ? sumBy(groupedEvents[date], 'size') : 0;

    data.push({ date: dayjs(date).toDate(), count });
    sizes.push(size);
  }
  return {
    total_events: sumBy(data, 'count'),
    total_size: sumBy(sizes),
    data
  };
});
